import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useClickOutside from '@hooks/useClickOutside';

import { formatRangeValue } from '@features/filter/static/filterUtil';
import FilterInput from '@features/filter/v2/FilterInput';
import FilterName from '@features/filter/v2/FilterName';

import { clearSelectedFilterName, storeItemInGlobalFilter } from '@store/actions/FilterAction';

const FabricBalance = () => {
	const [priceRangeValue, setPriceRangeValue] = useState({ min: '', max: '' });
	const dispatch = useDispatch();
	const fabricBalanceRef = useRef(null);
	const { selectedCheckboxField } = useSelector((store) => store.slectedCheckBoxFieldStore);

	const onOutSideClick = () => {
		if (selectedCheckboxField === 'FABRIC_BALANCE') dispatch(clearSelectedFilterName());
	};

	useClickOutside(fabricBalanceRef, onOutSideClick);

	const onApplyPriceRange = () => {
		let data = {
			name: 'FABRIC_BALANCE',
			minPrice: parseFloat(priceRangeValue.min),
			maxPrice: parseFloat(priceRangeValue.max),
			key: priceRangeValue,
			value: `Fabric Balance: ${formatRangeValue(priceRangeValue)}`,
			identifier: `FABRIC_BALANCE`,
			type: 'INPUT_VALUE'
		};
		dispatch(storeItemInGlobalFilter(data));
		onClearInput();
	};

	const onClearInput = () => {
		setPriceRangeValue({ min: '', max: '' });
	};

	const onChangePrice = (e) => {
		const { name, value } = e.target;
		setPriceRangeValue((prev) => ({
			...prev,
			[name]: value
		}));
	};
	return (
		<div ref={fabricBalanceRef}>
			<FilterName type="FABRIC_BALANCE" />
			<FilterInput
				inputValue={priceRangeValue}
				onChangeHandler={onChangePrice}
				onApplyHandler={onApplyPriceRange}
				placeHolderOne="Min"
				placeHolderTwo="Max"
				type="FABRIC_BALANCE"
				onClearInputFields={onClearInput}
			/>
		</div>
	);
};

export default FabricBalance;
